<template>
  <svg
    width="23"
    height="18"
    viewBox="0 0 23 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.5 0C1.397 0 0.5 0.897 0.5 2V18H10.5V16H2.5V2H12.5V9C12.5 7.37 13.292 5.93544 14.5 5.02344V2C14.5 0.897 13.603 0 12.5 0H2.5ZM4.5 4V6H6.5V4H4.5ZM8.5 4V6H10.5V4H8.5ZM17.5 6C15.818 6 14.5 7.317 14.5 9C14.5 10.683 15.818 12 17.5 12C19.182 12 20.5 10.683 20.5 9C20.5 7.317 19.182 6 17.5 6ZM4.5 8V10H6.5V8H4.5ZM8.5 8V10H10.5V8H8.5ZM17.5 8C18.08 8 18.5 8.421 18.5 9C18.5 9.579 18.08 10 17.5 10C16.92 10 16.5 9.579 16.5 9C16.5 8.421 16.92 8 17.5 8ZM4.5 12V14H6.5V12H4.5ZM8.5 12V14H10.5V12H8.5ZM17.5 13C14.649 13 12.5 14.4558 12.5 16.3848V18H22.5V16.3848C22.5 14.4558 20.351 13 17.5 13ZM17.5 15C18.97 15 19.9895 15.504 20.3535 16H14.6465C15.0095 15.504 16.03 15 17.5 15Z"
      fill="#939393"
    />
  </svg>
</template>

<script>
/**
 * @fileoverview Client Icon
 *
 * @author Cameron Bulock <cameron.bulock@quavo.com>
 */

export default {
  name: "ClientIcon",
};
</script>

<style lang="scss" scoped>
</style>